// Optional display titles never replace canonical preview data.
export const getChatPreviewHeading = (value) => typeof value === 'string' &&
    value.length > 0 && value.length <= 56 && value.trim() === value &&
    !/[^\S ]| {2}/u.test(value) &&
    !Array.from(value).some((character) => character.charCodeAt(0) < 32 || character.charCodeAt(0) === 127)
    ? value : null;
